export const DEFAULT_PAGE_SIZE = 10
export const PAGE_SIZES = ['10', '20', '30']
